import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FixedAmountRuleState } from './types'
import { validateFixedAmountRule } from './validate'
import { buildFixedAmountFormValues } from './buildFormValues'
import { FixedAmountRuleStep } from './RuleStep.view'
import { FixedAmountConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Lorsque le panier dépasse le <strong style={{ color: '#212121' }}>montant minimum</strong>, le client
		reçoit un <strong style={{ color: '#212121' }}>code promotionnel d&apos;un montant fixe</strong>{' '}
		(inférieur au seuil).
	</Typography>
)

function getInitialRuleFromCampaign(campaign: any): FixedAmountRuleState {
	return {
		discount: campaign.config?.discount?.value ?? null,
		threshold: campaign.config?.threshold ?? null,
	}
}

export const fixedAmountDiscountDefinition: CampaignDefinition<FixedAmountRuleState> = {
	type: CampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD,
	RuleStep: FixedAmountRuleStep,
	ConfirmationSummary: FixedAmountConfirmationSummary,
	defaultRule: { discount: null, threshold: null },
	validateRule: validateFixedAmountRule,
	buildFormValues: buildFixedAmountFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'none',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
}
